import { useState } from "react";

// Themed branded fallback (RP red gradient SVG). Always reachable, no network.
const FALLBACK =
    "data:image/svg+xml;utf8," +
    encodeURIComponent(
        `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 600'>
          <defs>
            <linearGradient id='g' x1='0' y1='0' x2='1' y2='1'>
              <stop offset='0%' stop-color='%23ffb422'/>
              <stop offset='55%' stop-color='%23ff7a18'/>
              <stop offset='100%' stop-color='%23b3261e'/>
            </linearGradient>
          </defs>
          <rect width='800' height='600' fill='url(%23g)'/>
          <g fill='white' opacity='0.95'>
            <text x='50%' y='52%' text-anchor='middle' font-family='Inter,Arial,sans-serif' font-weight='800' font-size='84' letter-spacing='-2'>RP TRADERS</text>
            <text x='50%' y='62%' text-anchor='middle' font-family='Inter,Arial,sans-serif' font-size='22' letter-spacing='4' opacity='0.85'>SPICE EXPORTERS · GUNTUR</text>
          </g>
        </svg>`
    );

/**
 * Drop-in <img> replacement with:
 *  - loading="lazy" by default
 *  - skeleton shimmer while loading
 *  - automatic fallback to RP Traders branded SVG on error
 */
export default function SafeImage({
    src,
    alt = "",
    className = "",
    loading = "lazy",
    eager = false,
    onError,
    ...rest
}) {
    const [loaded, setLoaded] = useState(false);
    const [errored, setErrored] = useState(false);
    return (
        <div className={`relative h-full w-full overflow-hidden ${errored ? "bg-brand-red/10" : "bg-black/5"}`}>
            {!loaded && !errored && (
                <div
                    aria-hidden
                    className="absolute inset-0 animate-pulse bg-gradient-to-br from-black/5 via-black/10 to-black/5"
                />
            )}
            <img
                src={errored ? FALLBACK : src}
                alt={alt}
                loading={eager ? "eager" : loading}
                decoding="async"
                onLoad={() => setLoaded(true)}
                onError={(e) => {
                    setErrored(true);
                    setLoaded(true);
                    if (onError) onError(e);
                }}
                className={`h-full w-full object-cover transition-opacity duration-500 ${
                    loaded ? "opacity-100" : "opacity-0"
                } ${className}`}
                {...rest}
            />
        </div>
    );
}
